import request from 'axios';
import { DEFAULT_PAGINATION_PAGE_SIZE } from 'common/pager/constants';

/* ACTIONS
================================================================================================ */
export const FETCH_CASE_STUDIES = 'crowdspring/marketing/FETCH_CASE_STUDIES';
export const FETCH_CASE_STUDIES_SUCCESS = 'crowdspring/marketing/FETCH_CASE_STUDIES_SUCCESS';

export const FETCH_REVIEWS = 'crowdspring/marketing/FETCH_REVIEWS';
export const FETCH_REVIEWS_REQUEST = 'crowdspring/marketing/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'crowdspring/marketing/FETCH_REVIEWS_SUCCESS';

export const FETCH_REVIEW_STATS = 'crowdspring/marketing/FETCH_REVIEW_STATS';
export const FETCH_REVIEW_STATS_SUCCESS = 'crowdspring/marketing/FETCH_REVIEW_STATS_SUCCESS';

export const CLEAR_REVIEWS = 'crowdspring/marketing/CLEAR_REVIEWS';

export const FETCH_REFERRALS = 'crowdspring/marketing/FETCH_REFERRALS';
export const FETCH_REFERRALS_SUCCESS = 'crowdspring/marketing/FETCH_REFERRALS_SUCCESS';

/* HELPERS
================================================================================================ */
export const createReferralsRequest = formData => request.post('/api/v1/referrals/', formData);

export const subscribeRequest = formData => request.post('/api/v1/landing-pages/log_visitor/', formData);


/* INITIAL STATES
================================================================================================ */
export const initialState = {
  caseStudies: [],
  reviews: [],
  reviewCount: 0,
  nextReviewPage: 1,
  fetchingReviews: false,
  referrals: [],
  reviewStats: {}
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REVIEW_STATS_SUCCESS:
      return {
        ...state,
        reviewStats: action.payload
      };
    case FETCH_CASE_STUDIES_SUCCESS:
      return {
        ...state,
        caseStudies: action.payload,
      };
    case FETCH_REVIEWS_REQUEST:
      return {
        ...state,
        fetchingReviews: true
      };
    case FETCH_REVIEWS_SUCCESS:
      return {
        ...state,
        reviews: [...state.reviews, ...action.payload.results],
        reviewCount: action.payload.count,
        nextReviewPage: state.nextReviewPage + 1,
        fetchingReviews: false
      };
    case CLEAR_REVIEWS:
      return {
        ...state,
        reviews: [],
        reviewCount: 0,
        nextReviewPage: 1
      };
    case FETCH_REFERRALS_SUCCESS:
      return {
        ...state,
        referrals: action.payload
      };
    default:
      return state;
  }
}

export const fetchReviewStatsIfNeeded = () => (dispatch, getState) => {
  const { marketing } = getState();

  if (Object.keys(marketing.reviewStats).length > 0) {
    return Promise.resolve();
  }

  return dispatch({
    type: FETCH_REVIEW_STATS,
    promise: request.get('/api/v1/csratings/stats/')
  });
};


export const fetchCaseStudies = () => (dispatch) => {
  return dispatch({
    type: FETCH_CASE_STUDIES,
    promise: request.get('/api/v1/case-studies/')
  });
};

export const fetchReviews = (subcatIds, opts={}) => (dispatch, getState) => {
  let { pageSize, sortBy } = opts;
  pageSize = pageSize || DEFAULT_PAGINATION_PAGE_SIZE;
  const { nextReviewPage } = getState().marketing;
  const offset = (nextReviewPage - 1)*pageSize;
  let queryStr = `?limit=${pageSize}&offset=${offset}&published=published`;
  if (subcatIds) {
    queryStr += subcatIds.reduce((acc, subcatId) => `${acc}&subcategories=${subcatId}`, '');
  }
  if (sortBy) {
    queryStr += `&sort=${sortBy}`;
  }
  const promise = request.get(`/api/v1/csratings/${queryStr}`);

  dispatch({
    type: FETCH_REVIEWS,
    promise
  });

  return promise;
};

export const clearReviews = () => {
  return {
    type: CLEAR_REVIEWS
  };
}

export const fetchReferrals = () => (dispatch) => {
  return dispatch({
    type: FETCH_REFERRALS,
    promise: request.get('/api/v1/referrals/')
  });
};



// WEBPACK FOOTER //
// ./marketing/ducks.js